// extracted by mini-css-extract-plugin
export default {"root":"SingleSignOn_root__UlO-X","card":"SingleSignOn_card__crr54","content":"SingleSignOn_content__wIIZO","logo":"SingleSignOn_logo__Smi3N"};